// ProductFruitsConnector.js
import React, { useEffect } from "react";
import useHelpCenter from "../../_hooks/useHelpCenter";
import { useDispatch, useSelector } from "react-redux";
import { ProductFruits } from "react-product-fruits";
import { createSupportTicket } from "../services/store/commons.actions";

const ProductFruitsConnector = () => {
    const { openHelpCenter } = useHelpCenter();
    const myOrganization = useSelector((state) => state.myOrganization);
    const selectedOrganization = useSelector((state) => state.authentication.user?.selectedOrganization);
    const user = useSelector((state) => state.authentication.user);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!window.productFruits) return;

        const handlePFChatInit = async (event) => {
            const { initialMessageToOperator, communicationHistory, onClose } = event.detail || {};

            // create ticket
            await dispatch(
                createSupportTicket({
                    userMail: user.mail,
                    userID: user.hubspotId,
                    userUUID: user.externalUUID,
                    organizationUUID: selectedOrganization.externalUUID,
                    organizationName: selectedOrganization.name,
                    companyID: selectedOrganization.hubspotId,
                    initialMessage: initialMessageToOperator,
                    chatHistory: communicationHistory,
                })
            );

            // If user closes the widget → restore PF button
            if (onClose) {
                onClose(() => {
                    openHelpCenter();
                });
            }
        };

        window.addEventListener("productfruits_button_ext_widget_init", handlePFChatInit);

        return () => {
            window.removeEventListener("productfruits_button_ext_widget_init", handlePFChatInit);
        };
    }, [user, selectedOrganization, dispatch, openHelpCenter]);

    if (myOrganization.productFruitsUser) {
        return (
            <ProductFruits
                workspaceCode={process.env.REACT_APP_PRODUCTFRUITS_WORKSPACE_ID}
                language="de"
                user={myOrganization.productFruitsUser}
                lifeCycle="unmount"
            />
        );
    }

    return null;
};

export default ProductFruitsConnector;
